import React, { useState, useRef } from "react"
import { useTranslation } from "react-i18next"
import { Grid } from "@material-ui/core"
import { HeaderHLPure, GridPure, InputHLPure, TextAreaHLPure, ButtonHLPure } from "../../pures"
import { MultiColumnComboBox } from "@progress/kendo-react-dropdowns"
import { filterBy } from "@progress/kendo-data-query"
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import { handleSelectedElements } from "../../../utils"

const AddOfferDetailsView = (props) => {
  const { t } = useTranslation()
  const {
    discountDetails,
    setDiscountDetails,
    termsAndConditions,
    setTermsAndConditions,
    productsSelected,
    setProductsSelected,
    transl,
    deleteDiscountProductList,
    productsCatalog,
    setProductsCatalog
  } = props

  const { products } = props.catalogInsert
  const [loading, setLoading] = useState(false)
  const timeout = useRef()
  const [addProduct, setAddProduct] = useState("0")
  const [infoProduct, setInfoProduct] = useState({
    name: "",
    keyIdentifier: ""
  })

  const handleChange = (event) => {
    setAddProduct(event.target.value);
  };

  const onInputChange = ({ target }, setValue, property) => {
    if (property) {
      setValue((prev) => { return { ...prev, [property]: target.value } })
    } else {
      setValue(target.value)
    }
  }
  const filterData = (filter) => {
    const localData = products.filter((item) => {
      if (!productsSelected.some(branch => branch.id === item.id)) return item
    })

    return filterBy(localData, filter)
  }

  const handleFilterChange = (event) => {
    if (timeout.current) {
      clearTimeout(timeout.current)
    }
    timeout.current = setTimeout(() => {
      setProductsCatalog(filterData(event.filter))
      setLoading(false)
    }, 500)
    setLoading(true)
  }

  return (
    <Grid container spacing={2}>
      {/* Table and Header */}
      <Grid item xs={12}>
        <HeaderHLPure headingNumber={3} style={{ fontSize: '20px' }} title={transl("offerDetails")} />
      </Grid>

      <InputHLPure
        typeInput={"text"}
        labelInput={transl('discountDetails')}
        valueInput={discountDetails}
        handleChangeInput={(event) => onInputChange(event, setDiscountDetails)}
        inputActive
      />

      <Grid item xs={12}>
        <TextAreaHLPure
          labelTextArea={transl('termsAndConditions')}
          valueTextData={termsAndConditions}
          handleChangeTextArea={(event) => onInputChange(event, setTermsAndConditions)}
        />
      </Grid>

      <Grid item xs={12}>
        <HeaderHLPure headingNumber={3} style={{ fontSize: '20px' }} title={transl('titleProducts')} />
      </Grid>

      <Grid item xs={12}>
        <FormControl component="fieldset">
          <FormLabel component="legend">{transl("typeTitle")}</FormLabel>
          <RadioGroup aria-label="gender" name="gender1" value={addProduct} onChange={handleChange}>
            <FormControlLabel value="1" control={<Radio />} label={transl("newProduct")} />
            <FormControlLabel value="0" control={<Radio />} label={transl("existingProduct")} />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        {
          !Number(addProduct) ?
            <MultiColumnComboBox
              data={productsCatalog}
              columns={[
                {
                  field: "keyIdentifier",
                  header: "Clave",
                  width: "100px",
                },
                {
                  field: "name",
                  header: "Nombre",
                  width: "300px",
                },
              ]}
              textField={"name"}
              filterable={true}
              onFilterChange={handleFilterChange}
              onChange={(event) => handleSelectedElements(event, productsSelected, setProductsSelected, products, setProductsCatalog)}
              onClose={handleFilterChange}
              loading={loading}
              placeholder={transl('selectOption')}
              value={null}
            /> :
            <>
              <InputHLPure
                typeInput={"text"}
                labelInput={transl('productName')}
                valueInput={infoProduct.name}
                handleChangeInput={(event) => onInputChange(event, setInfoProduct, 'name')}
                inputActive
              />
              <div style={{ marginTop: '24px' }}>
                <InputHLPure
                  typeInput={"text"}
                  labelInput={transl('productKey')}
                  valueInput={infoProduct.keyIdentifier}
                  handleChangeInput={(event) => onInputChange(event, setInfoProduct, 'keyIdentifier')}
                  inputActive
                />
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ButtonHLPure
                  style={{ marginTop: '24px' }}
                  nameBtn={'Agregar producto'}
                  primary outlined={true}
                  onClick={() => {
                    setProductsSelected([...productsSelected, infoProduct])
                    setInfoProduct({ name: "", keyIdentifier: "" })
                    setAddProduct("0")
                  }}
                />
              </div>
            </>
        }
      </Grid>

      <Grid item xs={12}>
        <GridPure
          {...props}
          dataGrid={productsSelected}
          skip={0}
          take={11}
          rowsItems={[{
            field: 'keyIdentifier',
            title: t("publicityView.addPublicityColumnKeyIdentifier"),
            width: '20%'
          },
          {
            field: 'name',
            title: t("publicityView.addPublicityColumnName"),
            width: '40%'
          },
          {
            field: 'Acciones',
            title: t("publicityView.addPublicityColumnActions"),
            width: '15%',
            actions: true,
          }]}
          actions={[
            {
              type: 'icon',
              value: 'k-icon k-i-delete k-i-trash',
              onClick: (dataItem) => { deleteDiscountProductList(dataItem) }
            },
          ]}
          iconOneActive
          labelOneActions={t("configurationPanelView.delete.domain.btn")}
          activeDialog1
          styleCol1={"configurationDomainsView-style-col-1"}
          labelsColumnsNoPadding={false}
        />
      </Grid>
    </Grid>
  )
}

export { AddOfferDetailsView as default }